module.exports = __webpack_public_path__ + "static/img/72-1.ddc1bcc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/72-1.jpg
// module id = 6bnG
// module chunks = 0